import { Button, Typography } from '@mui/material';
import React, { Component } from 'react'

export class IntegerAmountSelector extends Component {
    state = {
        fieldError: null
    }
    render() {
        const { minValue, value, maxValue, label, error, helperText, onChange } = this.props;
        return (
            <div style={{ display: "flex", flexDirection: "row", gap: 5 }}>
                <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
                    <Typography style={{ userSelect: 'none', fontSize: 14 }}>{label}</Typography>
                    <div style={{ display: "flex", border: "0.5px solid #dedede", borderRadius: 5, height: 40, flexDirection: "row" }}>
                        <Button
                            disabled={minValue != null && parseInt(value) <= (minValue)}
                            onClick={() => {
                                if (minValue == null || parseInt(value) > minValue) {
                                    onChange(parseInt(value) - 1);
                                }
                            }}
                            variant='contained' style={{ flex: 1, borderTopRightRadius: 0, borderBottomRightRadius: 0 }}>-</Button>
                        <input error={error} style={{ border: 'none', borderWidth: 0, borderRadius: 0, flex: 4, textAlign: "center" }} helperText={helperText} onChange={(evt) => {
                            if (/^0|[1-9][0-9]*$/.test(evt.target.value)) {
                                if (minValue != null && parseInt(evt.target.value) < minValue) {
                                    this.setState({ fieldError: `Der Wert darf nicht kleiner als ${minValue} sein.` });
                                } else if (maxValue != null && parseInt(evt.target.value) > maxValue) {
                                    this.setState({ fieldError: `Der Wert darf nicht größer als ${maxValue} sein.` });
                                } else {
                                    this.setState({ fieldError: null });
                                    onChange(evt.target.value);
                                }
                            }
                        }} value={value} key={label + "_" + value} />
                        <Button onClick={() => {
                            if (maxValue == null || parseInt(value) < maxValue) {
                                onChange(parseInt(value) + 1);
                            }
                        }} disabled={maxValue != null && parseInt(value) >= maxValue} variant='contained' style={{ flex: 1, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}>+</Button>
                    </div>
                </div>
                {this.state.fieldError && <Typography style={{ color: "red", fontSize: 12 }}>{this.state.fieldError}</Typography>}
            </div>
        )
    }
}

export default IntegerAmountSelector